




















































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import { getWithdraw } from '@/api';
import { Withdraw } from '@/types/withdraw';
import useWithdraw from '@/use/useWithdraw';
import withdrawItemTableOption from '@/table/Withdraw/withdraw-item';
import depositItemTableOption from '@/table/Withdraw/deposit-item';

const NOW = useFormat.date().computerShortDate();
const defaultWithdraw: Withdraw = {
  id: -1,
  bomId: -1,
  code: '',
  type: '',
  status: '',
  items: [],
  remarks: '',
  createdAt: '',
  updatedAt: '',
  userId: -1,
  deletedAt: '',
};

const CommonModalWithWithdrawInfo = defineComponent({
  setup() {
    const {
      translateType, statusClassMap, translateStatus, typeClassMap,
    } = useWithdraw();
    const modal = ref(null);
    const item: Withdraw = reactive(defaultWithdraw);

    async function open(id: number) {
      const result = (await getWithdraw(id)).data;
      item.id = result.id;
      item.bomId = result.bom_id;
      item.status = result.status;
      console.log(item.status);
      item.type = result.type;
      item.code = result.code;
      item.items = result.items || [];
      item.createdAt = result.created_at;
      item.updatedAt = result.updated_at;
      item.deletedAt = result.deleted_at;
      item.userId = result.user_id;
      item.remarks = result.remarks;
      // item.user = result.user;

      (modal.value as any).open();
    }

    function close() {
      item.id = defaultWithdraw.id;
      item.bomId = defaultWithdraw.bomId;
      item.status = defaultWithdraw.status;
      item.items = defaultWithdraw.items;
      item.code = defaultWithdraw.code;
      item.type = defaultWithdraw.type;
      item.createdAt = defaultWithdraw.createdAt;
      item.updatedAt = defaultWithdraw.updatedAt;
      item.deletedAt = defaultWithdraw.deletedAt;
      item.userId = defaultWithdraw.userId;
      // item.user = defaultWithdraw.user;

      (modal.value as any).close();
    }

    // use this to manually paginate pr item;
    const page = ref(1);
    const PERPAGE = 15;
    const paginator = computed(() => ({
      perPage: PERPAGE,
      total: item.items?.length,
      from: (page.value - 1) * PERPAGE,
      to: (page.value * PERPAGE),
      currentPage: 1,
      lastPage: item.items?.length === 0 ? 1 : Math.ceil((item.items as any).length / PERPAGE),
      totalPages: item.items?.length === 0 ? 1 : Math.ceil((item.items as any).length / PERPAGE),
    }));
    const displayData = computed(() => {
      if ((item.items as any).length < paginator.value.to) return (item.items as any).slice(paginator.value.from, (item.items as any).length);
      return (item.items as any).slice(paginator.value.from, paginator.value.to);
    });

    return {
      open,
      close,
      modal,
      translateStatus,
      translateType,
      statusClassMap,
      typeClassMap,

      withdrawItemTableOption,
      depositItemTableOption,
      item,
      page,
      PERPAGE,
      pagination: paginator,
      displayData,
    };
  },
});

export default CommonModalWithWithdrawInfo;
